import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

interface ErrorMap {
    [key: string]: string | any,
}

function useErrorHandle() {
    const navigate = useNavigate();
    const errorMap:ErrorMap = {
        "error-01" : "logout",
    }
    const handleError = (errorCode: string, message:string) => {
        let key = errorMap[errorCode];
        switch (key) {
            case "logout":
                navigate("/errorLogout/"+errorCode);
                break;
            default:
                toast.error(message)
                break;
        }

    }


    return { handleError };
}

export default useErrorHandle;
